var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyProjCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Kopieren"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kopieren",
    clipPath: "url(#clip-Kopieren)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1408",
    transform: "translate(-16769 -4691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_541",
    d: "M30.5,10.521h-11a4.005,4.005,0,0,0-4,4v1h-1a4,4,0,0,0-4,4v11a4,4,0,0,0,4,4h11a4,4,0,0,0,4-4v-1h1a4,4,0,0,0,4-4v-11a4.005,4.005,0,0,0-4-4m-3,20a2,2,0,0,1-2,2h-11a2,2,0,0,1-2-2v-11a2,2,0,0,1,2-2h1v8a4,4,0,0,0,4,4h8Zm5-5a2,2,0,0,1-2,2h-11a2,2,0,0,1-2-2v-11a2,2,0,0,1,2-2h11a2,2,0,0,1,2,2Z",
    transform: "translate(16769 4691)",
    fill: "inherit"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2479",
    width: 334.978,
    height: 45,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyProjCard);
export default __webpack_public_path__ + "static/media/copy-proj-card.527193ce.svg";
export { ForwardRef as ReactComponent };